module.exports = __webpack_public_path__ + "img/ats-header.d5a453bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ats-header.png
// module id = 9vtF
// module chunks = 1